import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

function OfferCurrencyAlert() {
  return (
    <Alert
      type='info'
      showIcon
      icon={<InfoCircleOutlined />}
      message={
        <>
          Moedas não configuradas manualmente serão convertidas automaticamente seguindo o valor do câmbio atual.
          Transações Internacionais possuem uma cobrança de taxa diferenciada. Clique{' '}
          <a
            href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807397109-Quais-s%C3%A3o-as-taxas-cobradas-pela-Eduzz-na-venda-de-produtos-'
            target='_blank'
            rel='noopener noreferrer'
          >
            aqui
          </a>{' '}
          e saiba mais!
        </>
      }
    />
  );
}

export { OfferCurrencyAlert };
